export const CHANGE_SCORE = 'CHANGE_SCORE';

export function changeScoreKatz(newScore){
    return {type: CHANGE_SCORE, payload: newScore};
}